/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.WATERFALL_AVAILABLE_FUNDS_ROW.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {
    FetchRequest,
    WaterfallAvailableFundsRowInput,
    WaterfallAvailableFundsRow,
    UUID
} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the creation of a new
 * waterfall_available_funds_row on the server. Only name, description and waterfall_available_funds_row type need to be specified for this purpose.
 * @param waterfall_available_funds_rowInput An object of type WaterfallAvailableFundsRowInput containing the input data for creating the waterfall_available_funds_row.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_create_waterfall_available_funds_row(waterfall_available_funds_rowInput: WaterfallAvailableFundsRowInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_AVAILABLE_FUNDS_ROW,
        method: HttpMethods.POST,
        query_parameters: {},
        body: waterfall_available_funds_rowInput,
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for updating an existing
 * waterfall_available_funds_row on the server.
 * @param waterfall_available_funds_row An object of type WaterfallAvailableFundsRow containing the updated waterfall_available_funds_row data.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_update_waterfall_available_funds_row(waterfall_available_funds_row: WaterfallAvailableFundsRow): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_AVAILABLE_FUNDS_ROW,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: waterfall_available_funds_row,
    };
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of waterfall_available_funds_rows
 * on the server.
 * @param transaction_id .The UUID of the transaction to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_waterfall_available_funds_rows(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_AVAILABLE_FUNDS_ROW,
        method: HttpMethods.GET,
        query_parameters: { transaction_id: transaction_id },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for deleting an existing
 * waterfall_available_funds_row on the server.
 * @param waterfall_available_funds_row_id The UUID of the waterfall_available_funds_row to delete.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_delete_waterfall_available_funds_row(waterfall_available_funds_row_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_AVAILABLE_FUNDS_ROW,
        method: HttpMethods.DELETE,
        query_parameters: { waterfall_available_funds_row_id: waterfall_available_funds_row_id },
    };
}
